import {
  LayoutType,
  StaticLandingDayOfWeekParamInput,
  StaticLandingEventParamInput,
  StaticLandingFreeSeriesParamInput,
  StaticLandingGenreParamInput,
  StaticLandingOriginalParamInput,
  StaticLandingRankingParamInput,
  StaticLandingRankingThemeParamInput,
  StaticLandingTodayNewParamInput,
  StaticLandingTodayUpParamInput,
  StaticLandingType,
} from '../graphql/generated/types';

interface StaticLandingLayoutInput
  extends Partial<StaticLandingTodayNewParamInput>,
    Partial<StaticLandingRankingParamInput>,
    Partial<StaticLandingRankingThemeParamInput>,
    Partial<StaticLandingOriginalParamInput>,
    Partial<StaticLandingGenreParamInput>,
    Partial<StaticLandingDayOfWeekParamInput>,
    Partial<StaticLandingTodayUpParamInput>,
    Partial<StaticLandingFreeSeriesParamInput>,
    Partial<StaticLandingEventParamInput> {}

interface Props {
  landingListType: StaticLandingType;
  layoutType: LayoutType;
  input?: StaticLandingLayoutInput;
}

export function generateStaticLandingLayoutId({
  landingListType,
  layoutType,
  input,
}: Props): string {
  const layoutPrefix = `static-landing-layout-${landingListType}-${layoutType}`;

  switch (landingListType) {
    case StaticLandingType.TodayNew:
      return `${layoutPrefix}-${input?.screenUid}-${input?.categoryUid}-${input?.subcategoryUid}`;
    case StaticLandingType.Ranking:
      return `${layoutPrefix}-${input?.screenUid}-${input?.categoryUid}-${input?.subcategoryUid}-${input?.rankingType}`;
    case StaticLandingType.RankingTheme:
      return `${layoutPrefix}-${input?.screenUid}-${input?.filterType}-${input?.sortType}`;
    case StaticLandingType.Original:
      return `${layoutPrefix}-${input?.screenUid}-${input?.categoryUid}-${input?.subcategoryUid}-${input?.sortType}-${input?.isComplete}`;
    case StaticLandingType.Genre:
      return `${layoutPrefix}-${input?.screenUid}-${input?.categoryUid}-${input?.subcategoryUid}-${input?.sortType}-${input?.isComplete}`;
    case StaticLandingType.DayOfWeek:
      return `${layoutPrefix}-${input?.screenUid}-${input?.categoryUid}-${input?.subcategoryUid}-${input?.dayTabUid}-${input?.bmType}`;
    case StaticLandingType.TodayUp:
      return `${layoutPrefix}-${input?.categoryUid}-${input?.subcategoryUid}`;
    case StaticLandingType.FreeSeries:
      return `${layoutPrefix}-${input?.screenUid}-${input?.categoryUid}-${input?.tabUid}`;
    case StaticLandingType.Event:
      return `${layoutPrefix}-${input?.categoryUid}`;
    default:
      return `${layoutPrefix}-${input?.categoryUid}-${input?.subcategoryUid}`;
  }
}
